import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import DatePicker, { registerLocale } from 'react-datepicker'
import { useAlert } from 'react-alert'
import moment from 'moment'
import ru from 'date-fns/locale/ru'
import * as actions from './actions'
import { InitialState } from './types'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'

import 'react-datepicker/dist/react-datepicker.css'

registerLocale('ru', ru)

export default () => {
  const [title, setTitle] = useState<string>('')
  const [position, setPosition] = useState<number>(0)
  const [availableAt, setAvailableAt] = useState<Date>(new Date())

  const { id } = useParams<{ id: string }>()

  const dispatch = useDispatch()
  const alert = useAlert()

  useEffect(() => {
    return dispatch(actions.destroy())
  })

  const { error } = useSelector(
    (state: { adminModuleCreate: InitialState }) => state.adminModuleCreate
  )

  useEffect(() => {
    if (error) {
      alert.error(error)
    }
  }, [error])

  const onChangeTitle = (event: ChangeEvent<HTMLInputElement>) => {
    setTitle(event.currentTarget.value)
  }

  const onChangePosition = (event: ChangeEvent<HTMLInputElement>) => {
    setPosition(parseInt(event.currentTarget.value))
  }

  const handleCreateModule = () => {
    dispatch(actions.createModule(id, title, position, moment(availableAt)))
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        <h2>Панель администрирования - Создание модуля</h2>
        <label htmlFor={'title'}>Название модуля:</label>
        <br />
        <input
          id={'title'}
          placeholder={'Введите название модуля'}
          value={title}
          onChange={onChangeTitle}
          style={{ marginBottom: 10, width: 200 }}
          required={true}
          autoComplete={'off'}
        />
        <br />
        <label htmlFor={'position'}>Позиция модуля:</label>
        <br />
        <input
          id={'position'}
          type={'number'}
          min={0}
          style={{ marginBottom: 10, width: 200 }}
          onChange={onChangePosition}
          required={true}
          value={position}
        />
        <br />
        <label htmlFor={'date'}>Дата запуска модуля:</label>
        <br />
        <DatePicker
          locale={'ru'}
          selected={availableAt}
          onChange={(date: Date) => setAvailableAt(date)}
          dateFormat={'Pp'}
          showTimeSelect={true}
        />
        <br />
        <br />
        <button onClick={handleCreateModule}>Создать модуль</button>
        <br />
        <br />
        {error ? <span style={{ color: 'red' }}>{error}</span> : null}
      </div>
      <Footer />
    </>
  )
}
